import { AgentForm } from '@/components/forms/AgentForm';
import { PageContainer } from '@/components/PageContainer';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/agents/$agentId')({
  component: RouteComponent,
  beforeLoad: () => {
    return {
      pageTitle: 'Edit Agent',
    };
  },
});

function RouteComponent() {
  const { agentId } = Route.useParams();

  return (
    <PageContainer>
      <AgentForm agentId={agentId} />
    </PageContainer>
  );
}
